import { SimpleGrid } from '@chakra-ui/react';
import { ICreditNoteSchema } from '@monetize/types/app';
import { formatCurrency } from '@monetize/utils/core';
import { ROUTES } from '../../../constants';
import {
  CreditNoteStatusEnumDisplay,
  CreditNoteTypeEnumDisplay,
} from '../../../constants/credits';
import { MFormFieldReadOnly } from '../MFormFieldReadOnly';
import { LookupTriggerContent } from './LookupTriggerContent';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface CreditNoteLookupPopoverProps {
  value: string;
  displayLabel?: string;
}

export function CreditNoteLookupPopover({
  value,
  displayLabel,
}: CreditNoteLookupPopoverProps) {
  if (!value) {
    return null;
  }
  return (
    <RecordLookupPopover
      recordId={value}
      endpoint={`/api/creditNotes/${value}`}
      buttonProps={{ lineClamp: 3 }}
      renderRecord={(record) => {
        const creditNote = record as ICreditNoteSchema;
        const recordName = creditNote.description ?? creditNote.id ?? value;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={creditNote.id}
              href={ROUTES.getAccountCreditNoteViewRoute(
                creditNote.accountId,
                creditNote.id,
              )}
              recordName={recordName}
              displayStatus={CreditNoteStatusEnumDisplay[creditNote.status]}
            />

            <SimpleGrid columns={2} gap={2} mt={2}>
              <MFormFieldReadOnly label="Type">
                {CreditNoteTypeEnumDisplay[creditNote.type]}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Amount">
                {formatCurrency(creditNote.amount, {
                  currency: creditNote.currency,
                })}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Amount w/o Tax">
                {formatCurrency(creditNote.amountWithoutTax, {
                  currency: creditNote.currency,
                })}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Tax">
                {formatCurrency(creditNote.tax, {
                  currency: creditNote.currency,
                })}
              </MFormFieldReadOnly>
              {creditNote.invoiceId && (
                <MFormFieldReadOnly label="Invoice ID">
                  {creditNote.invoiceId}
                </MFormFieldReadOnly>
              )}
            </SimpleGrid>
          </>
        );
      }}
    >
      <LookupTriggerContent displayLabel={displayLabel} value={value} />
    </RecordLookupPopover>
  );
}
